// components/MyPage/components/Dashboard.js
import React from "react";
import styled from "styled-components";
import { Calendar, BarChart } from "lucide-react";
import { ContentHeader, ContentTitle } from "./css";

const ProjectSummary = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
`;

const SummaryCard = styled.div`
  background-color: #f9fafb;
  border-radius: 6px;
  padding: 16px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  
  .title {
    font-size: 14px;
    color: #6b7280;
    margin-bottom: 8px;
  }
  
  .value {
    font-size: 24px;
    font-weight: 600;
    color: #111827;
  }
`;

const ActivitySection = styled.div`
  margin-top: 24px;
`;

const ActivityTitle = styled.h3`
  font-size: 16px;
  margin-bottom: 16px;
`;

const ActivityList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const ActivityItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  background-color: #f9fafb;
  border-radius: 6px;
  
  .icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    background-color: #e0f2fe;
    border-radius: 6px;
    color: #0284c7;
  }
  
  .content {
    flex: 1;
  }
  
  .title {
    font-weight: 500;
    margin-bottom: 4px;
  }
  
  .description {
    font-size: 14px;
    color: #6b7280;
  }
  
  .time {
    font-size: 12px;
    color: #9ca3af;
  }
`;

const Dashboard = () => {
  return (
    <>
      <ContentHeader>
        <ContentTitle>대시보드</ContentTitle>
      </ContentHeader>
      <ProjectSummary>
        <SummaryCard>
          <div className="title">총 프로젝트</div>
          <div className="value">5</div>
        </SummaryCard>
        <SummaryCard>
          <div className="title">완료된 작업</div>
          <div className="value">28</div>
        </SummaryCard>
        <SummaryCard>
          <div className="title">진행 중인 작업</div>
          <div className="value">12</div>
        </SummaryCard>
        <SummaryCard>
          <div className="title">예정된 마일스톤</div>
          <div className="value">3</div>
        </SummaryCard>
      </ProjectSummary>
      
      <ActivitySection>
        <ActivityTitle>최근 활동</ActivityTitle>
        <ActivityList>
          <ActivityItem>
            <div className="icon-wrapper">
              <Calendar size={18} />
            </div>
            <div className="content">
              <div className="title">웹 개발 프로젝트에 작업이 추가됨</div>
              <div className="description">새 작업 "API 개발" 추가</div>
              <div className="time">2시간 전</div>
            </div>
          </ActivityItem>
          <ActivityItem>
            <div className="icon-wrapper">
              <BarChart size={18} />
            </div>
            <div className="content">
              <div className="title">모바일 앱 프로젝트 진행률 업데이트</div>
              <div className="description">UI 디자인 작업 진행률: 75%</div>
              <div className="time">어제</div>
            </div>
          </ActivityItem>
        </ActivityList>
      </ActivitySection>
    </>
  );
};

export default Dashboard;